import { createSelector } from 'reselect';
import { getQueryParams } from '../utils/queryParams';

const getLocation = (
  state: import('../types/rootState').RootState
): import('../types/commontypes').Location => state.location;

const getpath = createSelector(getLocation, location => location.path);

const getIsFromNav = createSelector(getpath, (pathname = '') => !!getQueryParams(' nav', pathname));

export { getLocation, getpath, getIsFromNav };
